module.exports = __webpack_public_path__ + "img/case_bottom_008.2ebc9f93.png";